export enum ModelNamespace {
  Balus = 'Balus',
}
